import Paper from 'apollo-react/components/Paper';
import Table, { compareStrings } from 'apollo-react/components/Table';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';

export const CacheListTable = ({ isLoading, cacheListItems }) => {
  const translateString = useTranslation();

  const columns = [
    {
      header: translateString('Cache'),
      accessor: 'cache',
      sortFunction: compareStrings,
    },
  ];

  return (
    <Paper square>
      <Table
        columns={columns}
        rowId="cache"
        emptyProps={{
          text: translateString('No data to display'),
        }}
        rows={cacheListItems}
        initialSortedColumn="cache"
        initialSortOrder="asc"
        rowsPerPageOptions={[5, 10, 15, translateString('All')]}
        defaultRowsPerPage={10}
        isLoading={isLoading}
        tablePaginationProps={{
          labelDisplayedRows: ({ from, to, count }) =>
            `${from}-${to} ${translateString('of')} ${count}`,
          truncate: true,
          labelRowsPerPage: translateString('Rows'),
          pageText: translateString('Page'),
          ofText: translateString('of'),
          pageNumberInputProps: {
            InputProps: {
              inputProps: {
                'aria-label': 'pageNumber',
              },
            },
          },
        }}
      />
    </Paper>
  );
};
